import { Pipe, PipeTransform } from '@angular/core';
import { LayoutService } from '../layout/layout.service';

@Pipe({
  name: 'locale',
})
export class LocalePipe implements PipeTransform {
  constructor(private layoutService: LayoutService) {}

  transform(value: string): string {
    if (value == null || value === 'null') {
      return '';
    }
    const translatedValue = this.layoutService.translate(value);
    return translatedValue;
  }
}
